<template>
  <div id="full">
    <AccountNavbar />
    <transition name="appear" mode="out-in">
      <div class="form-editor-container" v-if="loaded">
        <FormEditorPdf ref="editor" :form="form" :emrJson="emrJson" @formUpdated="formUpdated" @openModal="openModal"
          v-if="form.type == 'FILE'" />
        <FormEditorHtml ref="editor" :form="form" :emrJson="emrJson" @formUpdated="formUpdated" v-else />
      </div>
    </transition>
    <transition name="modal" mode="out-in">
      <AppendComponentsModal v-if="modal.id == 'append-components'" @closeModal="closeModal"
        @appendComponents="appendComponents" />
      <SignatureModal v-else-if="modal.id == 'signature'" @closeModal="closeModal" @submitSignature="submitSignature" />
      <TextModal v-else-if="modal.id == 'text'" @closeModal="closeModal" @submitText="submitText" />
    </transition>
  </div>
</template>

<style scoped></style>

<script>
import AccountNavbar from "../components/AccountNavbar.vue";
import FormEditorPdf from '../components/form-editor-pdf/FormEditorPdf.vue';
import FormEditorHtml from '../components/form-editor-html/FormEditorHtml.vue';
import SignatureModal from '../modals/form-editor/SignatureModal.vue';
import TextModal from "../modals/form-editor/TextModal.vue";
import { latestVersion, getPublicJson, printForm } from "@/api";
import AppendComponentsModal from "@/modals/form-editor/AppendComponentsModal.vue";

export default {
  name: "FormEditorView",
  data() {
    return {
      form: null,
      loaded: false,
      saved: false,
      emrJson: null,
      modal: { id: '', open: false, data: {} },
      isPrinting: false
    };
  },
  async created() {
    const id = this.$route.params.id;
    try {
      this.loaded = false;
      this.form = await latestVersion(id);
      this.emrJson = await getPublicJson('/emrs/practicefusion.json')
      console.info('Fetched form info from backend', this.form);
    } catch (err) {
      console.error('Failed to fetch form info', err);
    } finally {
      this.loaded = true;
    }
  },
  mounted() {
    window.addEventListener('keydown', this.handleKeyDown);
  },
  unmounted() {
    window.removeEventListener('keydown', this.handleKeyDown);
  },
  beforeRouteLeave(to, from, next) {
    if (!this.saved) {
      const answer = confirm('Are you sure you want to leave without saving changes?');
      if (answer) {
        next();
      } else {
        next(false);
      }
    } else {
      next();
    }
  },
  methods: {
    formUpdated() {
      this.saved = true;
      this.$router.push('/forms');
      console.info('Form was updated');
    },
    submitText(text) {
      // Verify modal is open and data has an annotation
      if (!this.modal.open) return;
      if (!this.modal.data) return;

      const annot = this.modal.data;
      annot.data = text;
      this.closeModal();
    },
    submitSignature(base64) {
      // Verify modal is open and data has an annotation
      if (!this.modal.open) return;
      if (!this.modal.data) return;

      const annot = this.modal.data;
      annot.data = base64;
      this.closeModal();
    },
    openModal(id, data) {
      this.modal = { id: id, open: true, data: data }
    },
    closeModal() {
      this.modal = { id: '', open: false, data: {} }
    },
    handleKeyDown(event) {
      if (!(event.ctrlKey || event.metaKey)) {
        return;
      }

      if (event.key === 'p') {
        // Prevent the default save action
        event.preventDefault();

        // Download PDF instead
        this.printForm();
      }

      if (event.key === 'g') {
        event.preventDefault();
        if (this.form.type != 'HTML') {
          alert('Append components is only available on HTML forms')
          return;
        }

        this.openModal('append-components')
      }

    },
    appendComponents(components) {
      console.log('Appending components', components)

      const editor = this.$refs.editor;
      if (editor && editor.appendComponents != undefined) {
        editor.appendComponents(components);
      }

      this.closeModal();
    },
    async printForm() {
      try {
        this.isPrinting = true;
        const blob = await printForm(this.form.id);
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `${this.form.name}.pdf`
        a.click();
        window.URL.revokeObjectURL(url);

      } catch (err) {
        console.error(err);
      } finally {
        this.isPrinting = false;
      }
    }
  },
  components: { AccountNavbar, FormEditorPdf, FormEditorHtml, SignatureModal, AppendComponentsModal, TextModal },
};
</script>

<style scoped>
.form-editor-container {
  width: 100%;
  height: 100%;
}
</style>